import { render, staticRenderFns } from "./BerkleyPolicyDetailActionsGetPdfFile.vue?vue&type=template&id=20aed0f3"
import script from "./BerkleyPolicyDetailActionsGetPdfFile.vue?vue&type=script&lang=js"
export * from "./BerkleyPolicyDetailActionsGetPdfFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports